import { PREFIXES, toLanguageCode } from '#src/lib/i18n.ts';

const normalizePath = (pathname: string) =>
  pathname.toLowerCase().replace(/\/+$/, '') || '/';

/** English lives on the unprefixed URL. */
export const getLocalizedUrl = (
  origin: string,
  prefix: string | undefined,
  pathname: string
) => {
  const path = normalizePath(pathname);
  if (!prefix || prefix === '/en') {
    return `${origin}${path}`;
  }
  return `${origin}${prefix}${path === '/' ? '' : path}`;
};

export const getHrefLangUrls = (origin: string, pathname: string) => [
  ...Object.entries(PREFIXES).map(([prefix, locale]) => ({
    hrefLang: toLanguageCode(locale),
    href: getLocalizedUrl(origin, prefix, pathname),
  })),
  { hrefLang: 'x-default', href: getLocalizedUrl(origin, undefined, pathname) },
];
